import { Badge } from '../ui/badge';
import { Clock, ChevronRight, Timer, Users, ListTodo } from 'lucide-react';

export const TaskCard = ({ 
    title, 
    subtitle, 
    time, 
    status,
    isRunning,
    isShared,
    ownerName,
    hasTodos,
    todoCount,
    onClick,
    type = 'case' // 'case', 'reminder', 'deadline'
}) => {
    const statusColors = {
        'Open': 'bg-emerald-100 text-emerald-700',
        'In Progress': 'bg-amber-100 text-amber-700',
        'Pending': 'bg-orange-100 text-orange-700',
        'Closed': 'bg-slate-100 text-slate-600',
        'overdue': 'bg-red-100 text-red-700',
        'critical': 'bg-purple-100 text-purple-700',
        'upcoming': 'bg-blue-100 text-blue-700',
    };

    const dotColors = {
        'Open': 'bg-emerald-500',
        'In Progress': 'bg-amber-500',
        'Pending': 'bg-orange-500',
        'Closed': 'bg-slate-400',
        'overdue': 'bg-red-500',
        'critical': 'bg-purple-500',
        'upcoming': 'bg-blue-500',
    };

    return (
        <button
            onClick={onClick}
            className={`w-full p-4 rounded-2xl shadow-[0_2px_12px_rgb(0,0,0,0.04)] hover:shadow-[0_4px_20px_rgb(0,0,0,0.08)] border transition-all active:scale-[0.98] text-left ${
                isShared 
                    ? 'bg-blue-50/70 border-blue-100 hover:border-blue-200' 
                    : 'bg-white border-transparent hover:border-indigo-100'
            }`}
            data-testid={`task-card-${title?.replace(/\s+/g, '-').toLowerCase()}`}
        >
            <div className="flex items-center gap-4">
                {/* Status dot */}
                <div className={`w-3 h-3 rounded-full flex-shrink-0 ${dotColors[status] || 'bg-slate-300'}`} />
                
                {/* Content */}
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <h3 className="font-semibold text-foreground truncate">{title}</h3>
                        {isRunning && (
                            <Timer className="h-4 w-4 text-indigo-500 animate-pulse" />
                        )}
                        {isShared && (
                            <Users className="h-4 w-4 text-blue-500" />
                        )}
                        {hasTodos && (
                            <div className="flex items-center gap-1 bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full">
                                <ListTodo className="h-3 w-3" />
                                <span className="text-xs font-medium">{todoCount}</span>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-2 mt-0.5">
                        {subtitle && (
                            <p className="text-sm text-muted-foreground truncate">{subtitle}</p>
                        )}
                        {isShared && ownerName && (
                            <span className="text-xs text-blue-600 flex-shrink-0">• {ownerName}</span>
                        )}
                    </div>
                </div>
                
                {/* Right side */}
                <div className="flex items-center gap-3 flex-shrink-0">
                    {time && (
                        <div className="flex items-center gap-1 text-muted-foreground">
                            <Clock className="h-4 w-4" />
                            <span className="font-display text-sm">{time}</span>
                        </div>
                    )}
                    {status && type === 'deadline' && (
                        <Badge className={`${statusColors[status] || 'bg-slate-100'} border-0 font-medium`}>
                            {status}
                        </Badge>
                    )}
                    <ChevronRight className="h-5 w-5 text-slate-300" />
                </div>
            </div>
        </button>
    );
};

export default TaskCard;
